// src/utils/logoutUser.ts
import { supabase } from '@/lib/supabaseClient';

export async function logoutUser() {
  try {
    await supabase.auth.signOut();

    // 🔒 Datos de sesión / identidad
    localStorage.removeItem('id_usuario');
    localStorage.removeItem('email');
    localStorage.removeItem('email_empresa');
    localStorage.removeItem('id_perfil');
    localStorage.removeItem('id_empresa');

    // 🧹 Estado funcional del cliente
    localStorage.removeItem('cliente_activo');
    localStorage.removeItem('selected_worker');
    localStorage.removeItem('selected_service');
    localStorage.removeItem('selected_date');
    localStorage.removeItem('selected_slot');

    // 🧹 Flags de UI temporales
    localStorage.removeItem('open_client_register');
    localStorage.removeItem('open_client_register_step2');
    localStorage.removeItem('open_company_register');
    localStorage.removeItem('auth_origin');
    localStorage.removeItem('oauth_context');
    localStorage.removeItem('google_email');

    return { ok: true };
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
    return { ok: false, error };
  }
}
